import React from 'react';
import { Link } from 'gatsby';
import TopMenu from './top-menu';
import RightMenu from './right-menu';

const Header = () => {
    return (
        <div className="relative z-10 max-w-screen-xl mx-auto pb-10 px-10 lg:px-8 2xl:px-0">
            <div className="w-full pt-8 flex flex-col-reverse md:flex-row items-center justify-between">
                <div className="flex flex-col md:flex-row items-center">
                    <div className="text-2xl mr-4 font-heading font-semibold text-blue-500 dark:text-blue-300 py-4 md:py-0">
                        <Link to="/" title="Angelin Calu" className="inline-flex items-center group">
                            <svg
                                style={{ width: '4rem', height: '4rem' }}
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 513 513"
                            >
                                <circle cx="256.166" cy="256.002" r="256" fill="none" />
                                <circle
                                    cx="256.166"
                                    cy="256.002"
                                    r="255"
                                    stroke="#33BDF2"
                                    strokeOpacity=".42"
                                    strokeWidth="2"
                                />
                                <path
                                    d="M173.499 337.378a165.882 165.882 0 003.56-7.646 105.053 105.053 0 003.428-9.361l3.559-8.701a239.093 239.093 0 01-4.878-7.646 111.913 111.913 0 01-4.35-8.57 70.138 70.138 0 01-3.296-8.701c-.791-2.9-1.187-5.713-1.187-8.437 0-.176.659-.308 1.978-.396 1.406-.175 3.12-.307 5.141-.395a161.74 161.74 0 016.724-.132c2.461-.088 4.702-.132 6.724-.132a128.55 128.55 0 015.141-.132l2.11-.132a779.114 779.114 0 015.932-15.029c1.934-4.746 3.867-9.536 5.801-14.37 1.934-4.834 3.867-9.756 5.801-14.766a427.38 427.38 0 005.801-16.347c3.691-10.899 7.294-20.479 10.81-28.74a4577.09 4577.09 0 019.888-23.072c.351-.879.923-1.67 1.714-2.373a14.546 14.546 0 012.768-1.977 25.89 25.89 0 012.769-1.319 99.113 99.113 0 012.241-.791c.352-.088 1.67-.483 3.955-1.186 2.373-.703 5.054-1.45 8.042-2.241a182.387 182.387 0 018.833-2.11c2.988-.615 5.361-.923 7.119-.923H282c1.406 0 2.725.352 3.955 1.055 1.319.615 2.198 1.89 2.637 3.823 4.219 10.811 8.701 22.632 13.447 35.464 4.834 12.744 9.536 26.807 14.107 42.188a1145.444 1145.444 0 007.251 23.466c2.373 7.383 4.746 14.59 7.119 21.621l7.119 21.094a2917.77 2917.77 0 017.515 21.753c.791 3.164 1.582 5.669 2.373 7.515.879 1.846 1.67 3.296 2.373 4.35.703 1.055 1.274 1.846 1.714 2.373.439.44.659.923.659 1.451 0 .527-.835 1.054-2.505 1.582l-28.345 9.228a520.263 520.263 0 01-6.46 2.373 176.375 176.375 0 01-6.196 2.11c-1.934.615-3.648 1.098-5.142 1.45-1.406.439-2.417.659-3.032.659h-.791c-1.23 0-2.109-.396-2.637-1.187-.527-.703-.879-1.406-1.054-2.109-.879-2.9-1.758-5.493-2.637-7.778a605.357 605.357 0 00-2.637-6.988l-2.505-7.514c-.791-2.637-1.582-5.757-2.373-9.361-.175-.439-.659-.791-1.45-1.054-.791-.352-1.758-.615-2.9-.791a20.867 20.867 0 00-3.428-.264 48.252 48.252 0 00-3.428-.132c-3.34 0-6.064.044-8.174.132-2.021 0-3.823.044-5.405.132-1.582 0-3.12.044-4.614.132H243.372c-2.636-.088-5.053-.176-7.251-.264l-7.514-.264a425.615 425.615 0 01-6.856 17.798 630.64 630.64 0 01-7.383 17.139c-.175.703-.615 1.274-1.318 1.714-.615.439-1.274.659-1.977.659-.528 0-.835-.044-.923-.132-8.526-3.076-15.689-6.108-21.49-9.097-5.8-2.988-10.854-5.888-15.161-8.701zm88.858-118.52c-2.11 7.822-4.219 14.941-6.328 21.357-2.022 6.328-3.912 11.953-5.669 16.875a769.544 769.544 0 01-4.351 12.525c-1.23 3.339-2.109 5.932-2.637 7.778v1.186c0 .528-.044.879-.132 1.055h31.641a400.61 400.61 0 00-3.164-13.052 685.097 685.097 0 01-3.164-13.842 599 599 0 01-3.164-15.557c-1.055-5.537-2.066-11.646-3.032-18.325z"
                                    fill="url(#paint0_linear)"
                                />
                                <mask
                                    id="a"
                                    maskUnits="userSpaceOnUse"
                                    x="47.651"
                                    y="47.487"
                                    width="406"
                                    height="417"
                                    fill="#000"
                                >
                                    <path fill="#fff" d="M47.651 47.487h406v417h-406z" />
                                    <path d="M446.692 187.357a202.513 202.513 0 00-340.879-67.025 202.516 202.516 0 10333.615 221.853l-36.32-17.08a162.38 162.38 0 115.825-124.143l37.759-13.605z" />
                                </mask>
                                <path
                                    className="group-hover:animate-pulse"
                                    d="M446.692 187.357a202.513 202.513 0 00-340.879-67.025 202.516 202.516 0 10333.615 221.853l-36.32-17.08a162.38 162.38 0 115.825-124.143l37.759-13.605z"
                                    fill="url(#paint1_linear)"
                                />
                                <path
                                    d="M446.692 187.357a202.513 202.513 0 00-340.879-67.025 202.516 202.516 0 10333.615 221.853l-36.32-17.08a162.38 162.38 0 115.825-124.143l37.759-13.605z"
                                    stroke="#fff"
                                    strokeOpacity=".25"
                                    strokeWidth="10"
                                    mask="url(#a)"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear"
                                        x1="164.666"
                                        y1="256.002"
                                        x2="347.666"
                                        y2="256.002"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#FC00FF" />
                                        <stop offset="1" stopColor="#00DBDE" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint1_linear"
                                        x1="2.003"
                                        y1="68.543"
                                        x2="458.681"
                                        y2="440.996"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#FC00FF" />
                                        <stop offset="1" stopColor="#00DBDE" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            Angelin Calu
                        </Link>
                    </div>
                    <TopMenu />
                </div>
                <RightMenu />
            </div>
        </div>
    );
};

export default Header;
